import { render, staticRenderFns } from "./UpdateEventSurvey.vue?vue&type=template&id=54a98244"
import script from "./UpdateEventSurvey.vue?vue&type=script&lang=js"
export * from "./UpdateEventSurvey.vue?vue&type=script&lang=js"
import style0 from "./UpdateEventSurvey.vue?vue&type=style&index=0&id=54a98244&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports